var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CCard',[_c('CCardBody',{staticClass:"text-center"},[_c('CImg',{staticClass:"w-100",staticStyle:{"max-width":"200px"},attrs:{"src":"//statics.affili.ir/storage/assets/empty-page.png"}}),_c('div',{staticClass:"font-lg my-3"},[_vm._t("content"),_vm._t("button")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }